import React, { useEffect } from 'react';
import { Button, Dialog, Spinner, Icon } from '@economic/taco';
import { Trans } from '@lingui/macro';
import { Link } from 'react-router-dom';

import useQuery from '../../../../shared/hooks/useQuery';
import moneyflowValidationError from './moneyflow-validation-error.svg';
import MoneyflowOnboardDialogFooter from '../../../sales/invoicing/invoices/book-and-send/moneyflow/always-on-version/MoneyflowOnboardDialogFooter';

interface Props {
    onCancel: () => void;
    onDone: () => void;
}

export default function StepValidate({ onCancel, onDone }: Props) {
    const {
        loading: validationLoading,
        data: validationErrors,
        error,
    } = useQuery<string[]>('/moneyflow/company/getOnboardingValidationErrors');

    const validationSucceeded = !validationLoading && (!validationErrors || validationErrors.length === 0);

    useEffect(() => {
        if (validationSucceeded) {
            onDone();
        }
    }, [validationSucceeded]);

    if (validationLoading) {
        return <Spinner />;
    }

    if (error) {
        return <div className="moneyflow__onboarding moneyflow__onboarding__validation_error">{error.toString()}</div>;
    }

    if (validationSucceeded) {
        return <></>;
    }

    return (
        <>
            <div>
                <Dialog.Title>
                    <Trans>Sorry, we are missing some key information for you to continue.</Trans>
                </Dialog.Title>
                <div className="flex mt-12">
                    <div className="flex flex-col">
                        <strong>
                            <Trans>You are missing account information to continue with Instant payment</Trans>
                        </strong>
                        <div className="mt-8 mb-4">
                            {validationErrors.map(error => (
                                <div className="flex items-center mb-4">
                                    <Icon name="info" className="rounded-full yt-yellow-solid mr-2" />
                                    {error}
                                </div>
                            ))}
                        </div>

                        <p>
                            <Trans>
                                Please fill the information out at{' '}
                                <Link to="/settings/company/master-information">All settings</Link>
                            </Trans>
                        </p>
                    </div>
                    <img src={moneyflowValidationError} />
                </div>
                <div className="flex justify-end mt-20">
                    <Button appearance="primary" onClick={onCancel}>
                        <Trans>Close</Trans>
                    </Button>
                </div>
            </div>
            <MoneyflowOnboardDialogFooter />
        </>
    );
}
